<section class="not-found-container flex-center">
  @if (theme() === GbTheme.ThemeOne) {
    <div
      class="not-found-content flex-center"
      [style.background-image]="'url(' + s3BucketAssets() + '/global/web/common/404-image.webp)'"
    >
      <h2 class="heading">
        {{ 'not_found.title' | translate }}
      </h2>
      <p>
        {{ 'not_found.description' | translate }}
      </p>
      <a
        class="primary-font-medium go-to-home-button primary-button rounded-pill custom-button flex-center"
        routerLink="/"
        >{{ 'not_found.go_back_to_home' | translate }}</a
      >
    </div>
  }

  @if (theme() === GbTheme.ThemeTwo) {
    <div class="not-found-content-theme-two">
      <div class="not-found-content-inner-theme-two">
        <h1 class="heading-one text-center primary-font-bold">404</h1>

        <h2 class="heading-two">
          {{ 'not_found.title' | translate }}
        </h2>
        <p class="description-theme-two">
          {{ 'not_found.description' | translate }}
        </p>
        <a
          class="primary-font-medium go-to-home-button primary-button custom-button flex-center"
          routerLink="/"
          >{{ 'not_found.go_back_to_home' | translate }}</a
        >
      </div>
    </div>
  }
</section>
